<script>
    import geos from "../stores/geos";
    import {findNode, setFocusTo, slugify} from "../lib/lib";
    import {geoSave} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import Modal from '../components/Modal.svelte';
    import GeoAutocomplete from "./GeoAutocomplete.svelte";

    export let geo = null;
    export let closeCallback;

    let title = geo && geo.id > 0 ? "Επεξεργασία τοποθεσίας" : "Νέα τοποθεσία";

    const onNameFocusOut = event => {
        geo.name_el = geo.name_el.trim();
        geo.name_en = geo.name_en != null ? geo.name_en.trim() : '';

        if (geo.slug.trim().length == 0) {
            if (geo.name_en) {
                geo.slug = slugify(geo.name_en);
            } else {
                geo.slug = slugify(geo.name_el);
            }
        }
    }

    const save = async () => {
        if (geo.name_el.trim().length == 0 || geo.name_en.trim().length == 0) {
            app_alert.show('error', "Πληκτρολογήστε το όνομα της περιοχής και στις 2 γλώσσες!");
            return;
        }

        // Parent has change
         parent = null;
        if (geo.parent_id > 0) {
            let parent = findNode(geo.parent_id, $geos.tree);
            geo.level = parseInt(parent.level) + 1;
        }

        const [err, res] = await geoSave(geo);

        if (err) {
            alert('error ' + err);
            return;
        }

        success.show("Η περιοχή ενημερώθηκε.");

        geo.id = res.geo.id;
        close(geo);
    }


    const close = param => {
        geo = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

</script>

{#if geo}
    <Modal {title} on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-md-6">
                    <label>Id: { geo.id > 0 ? geo.id : 'ΝΕΟ' }</label>
                </div>
                <div class="col-md-6">
                    <label>Επίπεδο: { geo.level }</label>
                </div>
            </div>

            {#if geo.level > 0}
                <div class="form-group">
                    <label>Μαμά</label>
                    <GeoAutocomplete bind:geoId="{ geo.parent_id }" minLevel="1" maxLevel="4"/>
                </div>
            {/if}

            <hr style="margin-top: none">
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="geo-name-el" bind:value="{ geo.name_el }"
                       on:focusout={onNameFocusOut}>
            </div>
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="geo-name-en" bind:value="{ geo.name_en }"
                       on:focusout={onNameFocusOut}>
            </div>
            <div class="form-group">
                <label>Link</label>
                <input type="text" class="form-control" id="geo-slug" bind:value="{ geo.slug }">
            </div>
            <div class="form-group">
                <label>Συντεταγμένες</label>
                <input type="text" class="form-control" bind:value="{ geo.latlng }">
            </div>

            <hr>
            <div class="text-right">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}